module.exports = __webpack_public_path__ + "img/20191217163643360截图20191217101536642.a1955cdc.jpg";